import {
  faCartShopping,
  faEnvelope,
  faFilePdf,
  faMobileRetro,
  faSquarePhone,
} from "@fortawesome/free-solid-svg-icons";

import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  ListGroup,
  Row,
  Offcanvas,
} from "react-bootstrap";
import { Link, Outlet } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../context/AuthContext";
import Cookies from "js-cookie";
import { BASEURL, GetCustomerId, GetToken, GetUserId } from "../CONSTANTS";
import { useLocation } from "react-router-dom";
import { useCustomScreen } from "./Utils";

const ProfileLayout = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [customerDetails, setCustomerDetails] = useState({});
  const { isIpadProPortrait } = useCustomScreen();

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  const [isMediumScreen, setIsMediumScreen] = useState(
    window.innerWidth > 768 && window.innerWidth <= 1023
  );
  const [isLargeScreen, setIsLargeScreen] = useState(
    window.innerWidth >= 1024 && window.innerWidth <= 1200
  );
  const [isXlScreen, setIsXlScreen] = useState(
    window.innerWidth > 1200 && window.innerWidth <= 1400
  );
  const [isXxlScreen, setIsXxlScreen] = useState(
    window.innerWidth > 1400 && window.innerWidth <= 2000
  );
  const [is4kScreen, setIs4kScreen] = useState(window.innerWidth > 2000);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
      setIsMediumScreen(window.innerWidth > 768 && window.innerWidth <= 1023);
      setIsLargeScreen(window.innerWidth >= 1024 && window.innerWidth <= 1200);
      setIsXlScreen(window.innerWidth > 1200 && window.innerWidth <= 1400);
      setIsXxlScreen(window.innerWidth > 1400 && window.innerWidth <= 2000);
      setIs4kScreen(window.innerWidth > 2000);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const location = useLocation();

  const isCreditPurcase = location.pathname === "/profile/credits-purchase";

  // Toggle menu
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

useEffect(() => {
  const fetchUserDetails = async () => {
    try {
      const response = await fetch(`${BASEURL}customers/${GetCustomerId()}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${GetToken()}`,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const text = await response.text();
      if (!text) {
        console.warn("Empty response body");
        return;
      }

      const result = JSON.parse(text);
      setCustomerDetails(result);
    } catch (error) {
      console.error("Failed to fetch user details:", error.message);
    }
  };

  fetchUserDetails();
}, []);


  // const checkTokenExpiration = () => {
  //   const token = window.localStorage.getItem("token");
  //   const expirationTime = window.localStorage.getItem("expirationTime");
  //   console.log("expirationTIme", expirationTime);
  //   console.log("checking token expiration");
  //   if (token && expirationTime) {
  //     const currentTime = Date.now();
  //     console.log("have token and expirationTime");
  //     if (currentTime > Number(expirationTime)) {
  //       console.log("Login Token has expired, Please login again");
  //       logout();
  //       window.location.reload();
  //     }
  //   }
  // };

  // useEffect(() => {
  //   console.log("checking token expiration from use effect");
  //   checkTokenExpiration();

  //   const intervalId = setInterval(() => {
  //     console.log("checking");
  //     checkTokenExpiration();
  //   }, 21600000); // Check every 6 hours

  //   return () => clearInterval(intervalId);
  // }, []);

  return (
    <Container
      className="container-base"
      style={{
        height: "auto",
        marginTop: is4kScreen ? "5rem" : isIpadProPortrait ? "2rem" : "",
      }}
    >
      <Card
        style={{
          marginTop: is4kScreen
            ? "2rem"
            : isXxlScreen
            ? "3rem"
            : isXlScreen
            ? "2rem"
            : isLargeScreen
            ? "2rem"
            : "2.8rem",
          marginBottom: isSmallScreen
            ? "2rem"
            : isMediumScreen
            ? "2rem"
            : is4kScreen
            ? "2rem"
            : "1rem",
          flex: "1", // Ensures the card takes full available height
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Row style={{ flex: "1", overflow: "hidden" }}>
          {!isSmallScreen && !isIpadProPortrait && !isMediumScreen && (
            <Col
              className=""
              md={3}
              style={{ height: "100%", overflowY: "auto", padding: "1rem" }}
            >
              <ListGroup
                variant="flush"
                className="login-page"
                style={{ height: "100%" }}
              >
                <ListGroup.Item>
                  <h6
                    style={{
                      fontSize: is4kScreen
                        ? "2rem"
                        : isXxlScreen
                        ? "1.2rem"
                        : isXlScreen
                        ? ""
                        : isLargeScreen
                        ? ""
                        : isMediumScreen
                        ? ""
                        : "",
                    }}
                  >
                    <strong className="pb-2">
                      Welcome, {customerDetails.fullName}
                    </strong>
                  </h6>
                  <p
                    style={{
                      fontSize: is4kScreen
                        ? "2rem"
                        : isXxlScreen
                        ? ""
                        : isXlScreen
                        ? "1.1rem"
                        : isLargeScreen
                        ? ""
                        : isMediumScreen
                        ? ""
                        : "",
                      lineHeight: is4kScreen ? "4rem" : "",
                    }}
                  >
                    {customerDetails.email}
                  </p>
                </ListGroup.Item>
                <ListGroup.Item>
                  <h6
                    style={{
                      fontSize: is4kScreen
                        ? "2rem"
                        : isXxlScreen
                        ? "1.3rem"
                        : isXlScreen
                        ? ""
                        : isLargeScreen
                        ? ""
                        : isMediumScreen
                        ? ""
                        : "1.2rem",
                    }}
                  >
                    <b>Manage Orders</b>
                  </h6>
                  <div>
                    <p
                      style={{
                        fontSize: is4kScreen
                          ? "2rem"
                          : isXxlScreen
                          ? "1.2rem"
                          : isXlScreen
                          ? "1.1rem"
                          : isLargeScreen
                          ? ""
                          : isMediumScreen
                          ? ""
                          : "1.2rem",
                        lineHeight: is4kScreen ? "4rem" : "",
                      }}
                    >
                      <Link to="billing-info">Report History</Link>
                    </p>
                    <p
                      style={{
                        fontSize: is4kScreen
                          ? "2rem"
                          : isXxlScreen
                          ? "1.2rem"
                          : isXlScreen
                          ? "1.1rem"
                          : isLargeScreen
                          ? ""
                          : isMediumScreen
                          ? ""
                          : "1.2rem",
                      }}
                    >
                      <Link to="credits-purchase">Report Credit Balance</Link>
                    </p>
                  </div>
                </ListGroup.Item>
                <ListGroup.Item>
                  <h6
                    style={{
                      fontSize: is4kScreen
                        ? "2rem"
                        : isXxlScreen
                        ? "1.3rem"
                        : isXlScreen
                        ? ""
                        : isLargeScreen
                        ? ""
                        : isMediumScreen
                        ? ""
                        : "1.2rem",
                    }}
                  >
                    <b>Manage Account</b>
                  </h6>
                  <div>
                    <p
                      style={{
                        fontSize: is4kScreen
                          ? "2rem"
                          : isXxlScreen
                          ? "1.2rem"
                          : isXlScreen
                          ? "1.1rem"
                          : isLargeScreen
                          ? ""
                          : isMediumScreen
                          ? ""
                          : "1.2rem",
                        lineHeight: is4kScreen ? "4rem" : "",
                      }}
                    >
                      <Link to="change-password">Login Settings</Link>
                    </p>
                    <p
                      style={{
                        fontSize: is4kScreen
                          ? "2rem"
                          : isXxlScreen
                          ? "1.2rem"
                          : isXlScreen
                          ? "1.1rem"
                          : isLargeScreen
                          ? ""
                          : isMediumScreen
                          ? ""
                          : "1.2rem",
                      }}
                    >
                      <Link to="profile-info">Profile Information</Link>
                    </p>
                    <p
                      style={{
                        fontSize: is4kScreen
                          ? "2rem"
                          : isXxlScreen
                          ? "1.2rem"
                          : isXlScreen
                          ? "1.1rem"
                          : isLargeScreen
                          ? ""
                          : isMediumScreen
                          ? ""
                          : "1.2rem",
                        lineHeight: is4kScreen ? "4rem" : "",
                      }}
                    >
                      <Link to="order-history">Billing Information</Link>
                    </p>
                    <p
                      style={{
                        fontSize: is4kScreen
                          ? "2rem"
                          : isXxlScreen
                          ? "1.2rem"
                          : isXlScreen
                          ? "1.1rem"
                          : isLargeScreen
                          ? ""
                          : isMediumScreen
                          ? ""
                          : "1.2rem",
                      }}
                    >
                      <Link to="delivery-preferences">
                        Delivery Preferences
                      </Link>
                    </p>
                  </div>
                </ListGroup.Item>
                <ListGroup.Item>
                  <h6
                    style={{
                      fontSize: is4kScreen
                        ? "2rem"
                        : isXxlScreen
                        ? "1.3rem"
                        : isXlScreen
                        ? ""
                        : isLargeScreen
                        ? ""
                        : isMediumScreen
                        ? ""
                        : "1.2rem",
                    }}
                  >
                    <b>New Orders</b>
                  </h6>
                  <div>
                    <p
                      style={{
                        fontSize: is4kScreen
                          ? "2rem"
                          : isXxlScreen
                          ? "1.2rem"
                          : isXlScreen
                          ? "1.1rem"
                          : isLargeScreen
                          ? ""
                          : isMediumScreen
                          ? ""
                          : "1.2rem",
                        lineHeight: is4kScreen ? "4rem" : "",
                      }}
                    >
                      <Link to="/order-page">Order New Reports</Link>
                    </p>
                    <p
                      style={{
                        fontSize: is4kScreen
                          ? "2rem"
                          : isXxlScreen
                          ? "1.2rem"
                          : isXlScreen
                          ? "1.1rem"
                          : isLargeScreen
                          ? ""
                          : isMediumScreen
                          ? ""
                          : "1.2rem",
                      }}
                    >
                      <Link to="credits-purchase">Buy More Report Credits</Link>
                    </p>
                  </div>
                </ListGroup.Item>
                <ListGroup.Item>
                  <h6
                    style={{
                      fontSize: is4kScreen
                        ? "2rem"
                        : isXxlScreen
                        ? "1.3rem"
                        : isXlScreen
                        ? ""
                        : isLargeScreen
                        ? ""
                        : isMediumScreen
                        ? ""
                        : "1.2rem",
                    }}
                  >
                    <b>Get Support</b>
                  </h6>
                  <div>
                    <p
                      style={{
                        fontSize: is4kScreen
                          ? "2rem"
                          : isXxlScreen
                          ? "1.2rem"
                          : isXlScreen
                          ? "1.1rem"
                          : isLargeScreen
                          ? ""
                          : isMediumScreen
                          ? ""
                          : "1.2rem",
                        lineHeight: is4kScreen ? "4rem" : "",
                      }}
                    >
                      <Link to="/contact-us">Contact Us</Link>
                    </p>
                  </div>
                </ListGroup.Item>
              </ListGroup>
            </Col>
          )}

          {/* Main Content */}
          <Col
            md={
              isSmallScreen
                ? 12
                : isIpadProPortrait
                ? 12
                : isMediumScreen
                ? 12
                : 9
            }
            style={{
              height: "100%",
              overflowY: "auto", // Enables scrolling inside the content area
            }}
          >
            {/* Hamburger menu for small screens */}
            {(isSmallScreen || isIpadProPortrait || isMediumScreen) && (
              <>
                <Button
                  variant=""
                  className={`mb-3  ${isIpadProPortrait ? "mt-2 mr-2" : ""}`}
                  onClick={toggleMenu}
                >
                  <FontAwesomeIcon
                    icon={faBars}
                    style={{ fontSize: isIpadProPortrait ? "30px" : "25px" }}
                  />
                </Button>
                <Offcanvas
                  show={menuOpen}
                  onHide={toggleMenu}
                  placement="start"
                  className="custom-offcanvas"
                >
                  <Offcanvas.Header closeButton>
                    {/* <Offcanvas.Title
                      style={{ paddingLeft: "0.6em" }}
                      className=" w-100 test-start"
                    >
                      <br
                        style={{ paddingTop: "10px", paddingBottom: "10px" }}
                      />

                    </Offcanvas.Title> */}
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    <ListGroup variant="flush" className="login-page">
                      <ListGroup.Item>
                        <h6>
                          <strong
                            style={{
                              fontSize: isMediumScreen
                                ? "1.3rem"
                                : isIpadProPortrait
                                ? "1.7rem"
                                : "17px",
                            }}
                          >
                            welcome, {customerDetails.fullName}
                          </strong>
                        </h6>
                        <p>
                          <strong
                            style={{
                              fontSize: isMediumScreen
                                ? "1.4rem"
                                : isIpadProPortrait
                                ? "1.7rem"
                                : "17px",
                            }}
                          >
                            {customerDetails.email}
                          </strong>
                        </p>
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <h6
                          style={{
                            fontSize: isMediumScreen
                              ? "1.3rem"
                              : isIpadProPortrait
                              ? "1.7rem"
                              : "17px",
                          }}
                        >
                          <b>Manage Orders</b>
                        </h6>
                        <div>
                          <p
                            style={{
                              fontSize: isMediumScreen
                                ? "1.4rem"
                                : isIpadProPortrait
                                ? "1.9rem"
                                : "17px",
                            }}
                          >
                            <Link to="billing-info" onClick={toggleMenu}>
                              Report History
                            </Link>
                          </p>
                          <p
                            style={{
                              fontSize: isMediumScreen
                                ? "1.4rem"
                                : isIpadProPortrait
                                ? "1.9rem"
                                : "17px",
                            }}
                          >
                            <Link to="credits-purchase" onClick={toggleMenu}>
                              Report Credit Balance
                            </Link>
                          </p>
                        </div>
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <h6
                          style={{
                            fontSize: isMediumScreen
                              ? "1.3rem"
                              : isIpadProPortrait
                              ? "1.7rem"
                              : "17px",
                          }}
                        >
                          <b>Manage Account</b>
                        </h6>
                        <div>
                          <p
                            style={{
                              fontSize: isMediumScreen
                                ? "1.4rem"
                                : isIpadProPortrait
                                ? "1.9rem"
                                : "17px",
                            }}
                          >
                            <Link to="change-password" onClick={toggleMenu}>
                              Login Settings
                            </Link>
                          </p>
                          <p
                            style={{
                              fontSize: isMediumScreen
                                ? "1.4rem"
                                : isIpadProPortrait
                                ? "1.9rem"
                                : "17px",
                            }}
                          >
                            <Link to="profile-info" onClick={toggleMenu}>
                              Profile Information
                            </Link>
                          </p>
                          <p
                            style={{
                              fontSize: isMediumScreen
                                ? "1.4rem"
                                : isIpadProPortrait
                                ? "1.9rem"
                                : "17px",
                            }}
                          >
                            <Link to="order-history" onClick={toggleMenu}>
                              Billing Information
                            </Link>
                          </p>
                          <p
                            style={{
                              fontSize: isMediumScreen
                                ? "1.4rem"
                                : isIpadProPortrait
                                ? "1.9rem"
                                : "17px",
                            }}
                          >
                            <Link
                              to="delivery-preferences"
                              onClick={toggleMenu}
                            >
                              Delivery Preferences
                            </Link>
                          </p>
                        </div>
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <h6
                          style={{
                            fontSize: isMediumScreen
                              ? "1.3rem"
                              : isIpadProPortrait
                              ? "1.7rem"
                              : "17px",
                          }}
                        >
                          <b>New Orders</b>
                        </h6>
                        <div>
                          <p
                            style={{
                              fontSize: isMediumScreen
                                ? "1.4rem"
                                : isIpadProPortrait
                                ? "1.9rem"
                                : "17px",
                            }}
                          >
                            <Link to="/order-page" onClick={toggleMenu}>
                              Order New Reports
                            </Link>
                          </p>
                          <p
                            style={{
                              fontSize: isMediumScreen
                                ? "1.4rem"
                                : isIpadProPortrait
                                ? "1.9rem"
                                : "17px",
                            }}
                          >
                            <Link to="credits-purchase" onClick={toggleMenu}>
                              Buy More Report Credits
                            </Link>
                          </p>
                        </div>
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <h6
                          style={{
                            fontSize: isMediumScreen
                              ? "1.3rem"
                              : isIpadProPortrait
                              ? "1.7rem"
                              : "17px",
                          }}
                        >
                          <b>Get Support</b>
                        </h6>
                        <div>
                          <p
                            style={{
                              fontSize: isMediumScreen
                                ? "1.4rem"
                                : isIpadProPortrait
                                ? "1.9rem"
                                : "17px",
                            }}
                          >
                            <Link to="/contact-us" onClick={toggleMenu}>
                              Contact Us
                            </Link>
                          </p>
                        </div>
                      </ListGroup.Item>
                    </ListGroup>
                  </Offcanvas.Body>
                </Offcanvas>
              </>
            )}
            <div
              className="hide-scrollbar"
              style={{ height: "100vh", overflowY: "auto", padding: "1rem" }}
            >
              <Outlet />
            </div>
          </Col>
        </Row>
      </Card>
    </Container>

    // <Container
    //   className="container-base"
    //   style={{
    //     height: "100vh",
    //     display: "flex",
    //     flexDirection: "column",
    //   }}
    // >
    //   <Card
    //     className=""
    //     style={{
    //       flex: "1", // Ensures the card takes full available height
    //       display: "flex",
    //       flexDirection: "column",
    //       overflow: "hidden", // Prevents content from overflowing the Card itself
    //     }}
    //   >
    //     <Row style={{ flex: "1", overflow: "hidden" }}>
    //       {!isSmallScreen && (
    //         <Col md={3} style={{ height: "100%", overflowY: "auto" }}>
    //           <ListGroup variant="flush" className="login-page">
    //             <ListGroup.Item>
    //               <h6 style={{ fontSize: is4kScreen ? "2rem" : "1.2rem" }}>
    //                 <strong>Welcome, {customerDetails.fullName}</strong>
    //               </h6>
    //               <p style={{ fontSize: is4kScreen ? "2rem" : "1.2rem" }}>
    //                 {customerDetails.email}
    //               </p>
    //             </ListGroup.Item>
    //             {/* Other ListGroup Items Here */}
    //           </ListGroup>
    //         </Col>
    //       )}

    //       {/* Main Content Area with Scroll */}
    //       <Col
    //         md={isSmallScreen ? 12 : 9}
    //         style={{
    //           height: "100%",
    //           overflowY: "auto", // Enables scrolling inside the content area
    //         }}
    //       >
    //         {/* Small Screen Offcanvas */}
    //         {isSmallScreen && (
    //           <>
    //             <Button variant="" className="mb-3" onClick={toggleMenu}>
    //               <FontAwesomeIcon icon={faBars} style={{ fontSize: "25px" }} />
    //             </Button>
    //             <Offcanvas
    //               show={menuOpen}
    //               onHide={toggleMenu}
    //               placement="start"
    //               className="custom-offcanvas"
    //             >
    //               <Offcanvas.Header closeButton />
    //               <Offcanvas.Body>
    //                 <ListGroup variant="flush" className="login-page">
    //                   <ListGroup.Item>
    //                     <h6>
    //                       <strong style={{ fontSize: "17px" }}>
    //                         Welcome, {customerDetails.fullName}
    //                       </strong>
    //                     </h6>
    //                     <p>
    //                       <strong style={{ fontSize: "17px" }}>
    //                         {customerDetails.email}
    //                       </strong>
    //                     </p>
    //                   </ListGroup.Item>
    //                   {/* Other ListGroup Items Here */}
    //                 </ListGroup>
    //               </Offcanvas.Body>
    //             </Offcanvas>
    //           </>
    //         )}

    //         {/* Scrollable Content */}
    //         <div style={{ height: "100%", overflowY: "auto", padding: "1rem" }}>
    //           <Outlet />
    //         </div>
    //       </Col>
    //     </Row>
    //   </Card>
    // </Container>
  );
};

export default ProfileLayout;
